let usbDevice = null;

export const connectUSBPrinter = async (vendorId, productId) => {
  if (!navigator.usb) return false;
  try {
    const device = await navigator.usb.requestDevice({ filters: [{ vendorId, productId }] });
    await device.open();
    if (device.configuration === null) {
      await device.selectConfiguration(1);
    }
    const iface = device.configuration.interfaces.find((i) => i.alternates.some((a) => a.endpoints && a.endpoints.some((e) => e.direction === 'out')));
    const ifaceNumber = iface ? iface.interfaceNumber : 0;
    await device.claimInterface(ifaceNumber);
    usbDevice = device;
    return true;
  } catch {
    return false;
  }
};

export const disconnectUSBPrinter = () => {
  usbDevice = null;
};

const toMonochrome = (canvas) => {
  const ctx = canvas.getContext('2d');
  const w = canvas.width;
  const h = canvas.height;
  const img = ctx.getImageData(0, 0, w, h);
  const data = img.data;
  const bytesPerRow = Math.ceil(w / 8);
  const out = new Uint8Array(bytesPerRow * h);
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const i = (y * w + x) * 4;
      const v = (data[i] + data[i + 1] + data[i + 2]) / 3;
      const bit = v < 170 ? 1 : 0;
      const byteIndex = y * bytesPerRow + (x >> 3);
      const bitIndex = 7 - (x & 7);
      out[byteIndex] |= bit << bitIndex;
    }
  }
  return { w, h, bytesPerRow, out };
};

export const printUSBReceiptCanvas = async (canvas) => {
  if (!usbDevice) return false;
  try {
    const { w, h, bytesPerRow, out } = toMonochrome(canvas);
    const xL = bytesPerRow & 0xff;
    const xH = (bytesPerRow >> 8) & 0xff;
    const yL = h & 0xff;
    const yH = (h >> 8) & 0xff;
    const header = new Uint8Array([0x1b, 0x40, 0x1d, 0x76, 0x30, 0x00, xL, xH, yL, yH]);
    const footer = new Uint8Array([0x0a, 0x0a, 0x1d, 0x56, 0x00]);
    const payload = new Uint8Array(header.length + out.length + footer.length);
    payload.set(header, 0);
    payload.set(out, header.length);
    payload.set(footer, header.length + out.length);
    const ep = usbDevice.configuration.interfaces.flatMap(i => i.alternates.flatMap(a => a.endpoints || [])).find(e => e.direction === 'out');
    const endpointNumber = ep ? ep.endpointNumber : 1;
    await usbDevice.transferOut(endpointNumber, payload);
    return true;
  } catch {
    return false;
  }
};

export const printThermalViaUSB = async (element) => {
  const node = element.querySelector('.receipt-thermal') || element;
  const prev = { display: node.style.display, visibility: node.style.visibility, position: node.style.position, left: node.style.left, top: node.style.top };
  node.style.display = 'block';
  node.style.visibility = 'hidden';
  node.style.position = 'fixed';
  node.style.left = '-9999px';
  node.style.top = '0';
  const canvas = await import('html2canvas').then(m => m.default(node, { scale: 2, backgroundColor: '#ffffff' }));
  node.style.display = prev.display;
  node.style.visibility = prev.visibility;
  node.style.position = prev.position;
  node.style.left = prev.left;
  node.style.top = prev.top;
  return printUSBReceiptCanvas(canvas);
};

